/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const MenuSearchFill = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M18.62 13.03a5.5 5.5 0 1 1 1.41-1.41l2.68 2.67-1.42 1.42zM3 4h5v2H3zm0 7h5v2H3zm0 7h18v2H3z" />
  </Icon>
);
